import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { BleConnectionLogFiltersResult } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, BleConnectionLogFiltersResult>,
    'queryKey' | 'queryFn'
  >;
}

export const useBleConnectionLogFiltersRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, BleConnectionLogFiltersResult>(
    [Entities.BleConnectionLogs, 'filters'],
    async () => {
      const { data } = await api.v1AdminLogsBleConnectionLogsFiltersGet()
      return data
    },
    { ...options },
  )
}
